module.exports = __webpack_public_path__ + "img/jrLogo.e5acec9b.svg";